module.exports = __webpack_public_path__ + "static/bg.a90fad97.png";